import { render, staticRenderFns } from "./point.vue?vue&type=template&id=0c23c93d&"
import script from "./point.vue?vue&type=script&lang=js&"
export * from "./point.vue?vue&type=script&lang=js&"
import style0 from "./point.vue?vue&type=style&index=0&id=0c23c93d&prod&lang=css&"
import style1 from "./point.vue?vue&type=style&index=1&id=0c23c93d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports